<template>
  <v-card :height="heightCard" class="" flat style="box-shadow: 2px 2px 4px rgba(0,0,0,0.15);">
    <v-tabs v-model="active" color="transparent" slider-color="transparent" centered grow>
      <v-tab>
        Bienvenidos
        <router-link
          to="/celebremos-bienvenidos"
          :class="colorAddWelcome"
          title="Ver más bienvenidos"
          tag="img"
          src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/circle-plus-solid.svg" class="img-circle"
        >
        </router-link>
      </v-tab>
      <v-tab-item>
        <WelcomeHome />
      </v-tab-item>
      <v-tab>
        Cumpleaños
        <router-link
          to="/celebremos-cumpleanos"
          :class="colorAddBirthday"
          title="Ver más cumpleaños"
          tag="img"
          src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/circle-plus-solid.svg" class="img-circle"
        >
        </router-link>
      </v-tab>
      <v-tab-item>
        <BirthdaysHome />
      </v-tab-item>
      <v-tab>
        Nacimientos
        <router-link
          to="/celebremos-nacimientos"
          :class="colorAddBirth"
          title="Ver más nacimientos"
          tag="img"
          src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/circle-plus-solid.svg" class="img-circle"
        >
        </router-link>
      </v-tab>
      <v-tab-item>
        <BirthsHome />
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import BirthsHome from "./BirthsHome";
import BirthdaysHome from "./BirthdaysHome";
import WelcomeHome from "./WelcomeHome";

export default {
  components: {
    BirthsHome,
    BirthdaysHome,
    WelcomeHome
  },
  data() {
    return {
      active: 1,
    };
  },
  computed: {
    colorAddBirth() {
      return this.active === 2 ? 'green-security-new pt-1' : 'grey-security-new pt-1'
    },
    colorAddBirthday() {
      return this.active === 1 ? 'green-security-new pt-1' : 'grey-security-new pt-1'
    },
    colorAddWelcome() {
       return this.active === 0 ? 'green-security-new pt-1' : 'grey-security-new pt-1'
    },
    heightCard() {
      return this.$vuetify.breakpoint.smAndDown ? '270px' : '500px' 
    }
  },
};
</script>

<style scoped>
.img-circle{
  width: 13px;
  margin-left: 8px;
  margin-top: -4px
}
</style>